import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=12b8e94c&"
import script from "./HomeAdmin.vue?vue&type=script&lang=ts&"
export * from "./HomeAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports